export const MinutesFilled = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#F22F46" />
        <path d="M6 10H14" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
);
